/**
 * Streamer Rewards Service
 *
 * Handles API calls for the streamer rewards points system
 */

(function() {
  window.streamerRewardsService = {
    /**
     * Get user's points balance
     * @param {string} twitchId - User's Twitch ID
     * @returns {Promise}
     */
    getUserPoints(twitchId) {
      return axios.get(`/api/streamer/rewards/balance.php?twitchId=${twitchId}`);
    },

    /**
     * Get user's points history/transactions
     * @param {string} twitchId - User's Twitch ID
     * @returns {Promise}
     */
    getPointsHistory(twitchId) {
      return axios.get(`/api/streamer/rewards/transactions.php?twitchId=${twitchId}`);
    },

    /**
     * Get leaderboard
     * @returns {Promise}
     */
    getLeaderboard() {
      return axios.get(`/api/streamer/rewards/leaderboard.php`);
    }
  };
})();
